import { render } from "./AuditHistoryIcon.vue?vue&type=template&id=06ac9d6a&ts=true"
import script from "./AuditHistoryIcon.vue?vue&type=script&lang=ts"
export * from "./AuditHistoryIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__